import { GDProduct } from '../const';
import { getGDServiceForProduct } from '../utils';
import { repositoryFactories } from './rest';
import { GDServiceOptions, GoodDataParametersResult, RestApiOptions } from './types';

export * from './types';

type Factories = typeof repositoryFactories;
type GDRegistry = {
    [K in keyof Factories]: ReturnType<Factories[K]>;
};

let dataPromise: Promise<GoodDataParametersResult> | null = null;

export const invalidateGoodDataAPI = () => {
    dataPromise = null;
};

export const createGoodDataServices = (options: RestApiOptions) => {
    const registry = {} as Record<string, unknown>;

    const getGDService = async (serviceOptions?: GDServiceOptions) => {
        if (!dataPromise) dataPromise = options.request('/goodData/getParameters');
        const data = await dataPromise;
        return getGDServiceForProduct(serviceOptions?.product ?? GDProduct.MewsBI, data);
    };

    Object.entries(repositoryFactories).forEach(([name, createRepository]) => {
        registry[name] = createRepository(getGDService);
    });

    return registry as GDRegistry;
};
